import * as React from 'react';

export interface IServerStaticContext {
  status: number | null;
  redirect?: string | null;
}

const StaticContext = React.createContext<IServerStaticContext>({
  status: null,
  redirect: null
});

interface StaticContextProviderProps {
  children: React.ReactNode;
  value: any;
}

export const useStaticContext = () => {
  const context = React.useContext(StaticContext);
  if (!context)
    throw new Error('useStaticContext must be used within a StaticContextProvider');

  return context;
};

export const StaticContextProvider: React.FC<StaticContextProviderProps> = ({
  value,
  children
}) => {
  return <StaticContext.Provider value={value}>{children}</StaticContext.Provider>;
};
